import React from 'react'
import Player from "@madzadev/audio-player";


import './Reproductor.scss';

const Reproductor = () => {
    const colors = `html {
        --tagsBackground: #9440f3;
        --tagsText: #ffffff;
        --tagsBackgroundHoverActive: #2cc0a0;
        --tagsTextHoverActive: #ffffff;
        --searchBackground: #18191f;
        --searchText: #ffffff;
        --searchPlaceHolder: #575a77;
        --playerBackground: #18191f;
        --titleColor: #ffffff; 
        --timeColor: #ffffff;
        --progressSlider: #9440f3;
        --progressUsed: #ffffff;
        --progressLeft: #151616;
        --volumeSlider: #9440f3;
        --volumeUsed: #ffffff;
        --volumeLeft:  #151616;
        --playlistBackground: #181f1b;
        --playlistText: #575a77;
        --playlistBackgroundHoverActive:  #18191f;
        --playlistTextHoverActive: #ffffff;
    }`;

    const tracks = [
        {
            url: "../../audios/page-1.mp3",
            title: "01-Page 1",
            tags: ["house"],
        },
        {
            url: "../../audios/page-2.mp3",
            title: "01-Page 2",
            tags: ["house"],
        },
        {
            url: "../../audios/page-3.mp3",
            title: "01-Page 3",
            tags: ["house"],
        },
        {
            url: "../../audios/page-4.mp3",
            title: "01-Page 4",
            tags: ["house"],
        },
        {
            url: "../../audios/page-5.mp3",
            title: "01-Page 5",
            tags: ["house"],
        },
        {
            url: "../../audios/page-6.mp3",
            title: "01-Page 6",
            tags: ["house"],
        },
        {
            url: "../../audios/page-7.mp3",
            title: "01-Page 7",
            tags: ["house"],
        },
        {
            url: "../../audios/page-8.mp3",
            title: "01-Page 8",
            tags: ["house"],
        },
        {
            url: "../../audios/page-9.mp3",
            title: "02-Page 9",
            tags: ["dnb"],
        },
        {
            url: "../../audios/page-10.mp3",
            title: "03-Page 10",
            tags: ["dubstep"],
        },
        {
            url: "../../audios/page-11.mp3",
            title: "04-Page 11",
            tags: ["dubstep"],
        },
        {
            url: "../../audios/page-12.mp3",
            title: "05-Page 12",
            tags: ["dubstep"],
        },
        {
            url: "../../audios/page-13.mp3",
            title: "06-Page 13",
            tags: ["dubstep"],
        },
        {
            url: "../../audios/page-14.mp3",
            title: "07-Page 14",
            tags: ["dubstep"],
        },
        {
            url: "../../audios/page-15.mp3",
            title: "08-Page 15",
            tags: ["house"],
        },
        {
            url: "../../audios/page-16.mp3",
            title: "09-Page 16",
            tags: ["dnb"],
        },
        {
            url: "../../audios/page-17.mp3",
            title: "10-Page 17",
            tags: ["dubstep"],
        },
        {
            url: "../../audios/page-18.mp3",
            title: "11-Page 18",
            tags: ["dubstep"],
        },
        {
            url: "../../audios/page-20.mp3",
            title: "12-Page 20",
            tags: ["dubstep"],
        },
        {
            url: "../../audios/page-21.mp3",
            title: "13-Page 21",
            tags: ["dubstep"],
        },
        {
            url: "../../audios/page-22.mp3",
            title: "14-Page 22",
            tags: ["dubstep"],
        },
        {
            url: "../../audios/page-23.mp3",
            title: "15-Page 23",
            tags: ["dubstep"],
        },
        {
            url: "../../audios/page-24.mp3",
            title: "16-Page 24",
            tags: ["dubstep"],
        },
        {
            url: "../../audios/page-25.mp3",
            title: "17-Page 25",
            tags: ["dubstep"],
        },
        {
            url: "../../audios/page-26.mp3",
            title: "18-Page 26",
            tags: ["dubstep"],
        },
        {
            url: "../../audios/page-27.mp3",
            title: "19-Page 27",
            tags: ["dubstep"],
        },
        {
            url: "../../audios/page-28.mp3",
            title: "20-Page 28",
            tags: ["dubstep"],
        },
        {
            url: "../../audios/page-29.mp3",
            title: "21-Page 29",
            tags: ["dubstep"],
        },
        {
            url: "../../audios/page-30.mp3",
            title: "22-Page 30",
            tags: ["dubstep"],
        },
        {
            url: "../../audios/page-31.mp3",
            title: "23-Page 31",
            tags: ["dubstep"],
        },
        {
            url: "../../audios/page-32.mp3",
            title: "24-Page 32",
            tags: ["dubstep"],
        },
        {
            url: "../../audios/page-33.mp3",
            title: "25-Page 33",
            tags: ["dubstep"],
        },
        {
            url: "../../audios/page-34.mp3",
            title: "26-Page 34",
            tags: ["dubstep"],
        },
        {
            url: "../../audios/page-35.mp3",
            title: "27-Page 35",
            tags: ["dubstep"],
        },
        {
            url: "../../audios/page-36.mp3",
            title: "28-Page 36",
            tags: ["dubstep"],
        },
        {
            url: "../../audios/page-37.mp3",
            title: "29-Page 37",
            tags: ["dubstep"],
        },
        {
            url: "../../audios/page-38.mp3",
            title: "30-Page 38",
            tags: ["dubstep"],
        },
        {
            url: "../../audios/page-39.mp3",
            title: "31-Page 39",
            tags: ["dubstep"],
        },
        {
            url: "../../audios/page-40.mp3",
            title: "32-Page 40",
            tags: ["dubstep"],
        },
        {
            url: "../../audios/page-41.mp3",
            title: "33-Page 41",
            tags: ["dubstep"],
        },
        {
            url: "../../audios/page-42.mp3",
            title: "34-Page 42",
            tags: ["dubstep"],
        },
        {
            url: "../../audios/page-43.mp3",
            title: "35-Page 43",
            tags: ["dubstep"],
        },
        {
            url: "../../audios/page-44.mp3",
            title: "36-Page 44",
            tags: ["dubstep"],
        },
        {
            url: "../../audios/page-45.mp3",
            title: "37-Page 45",
            tags: ["dubstep"],
        },
        {
            url: "../../audios/page-46.mp3",
            title: "38-Page 46",
            tags: ["dubstep"],
        },
        {
            url: "../../audios/page-47.mp3",
            title: "39-Page 47",
            tags: ["dubstep"],
        },
        {
            url: "../../audios/page-48.mp3",
            title: "40-Page 48",
            tags: ["dubstep"],
        },
        {
            url: "../../audios/page-49.mp3",
            title: "41-Page 49",
            tags: ["dubstep"],
        },
        {
            url: "../../audios/page-50.mp3",
            title: "42-Page 50",
            tags: ["dubstep"],
        },
        {
            url: "../../audios/page-51.mp3",
            title: "43-Page 51",
            tags: ["dubstep"],
        },
        {
            url: "../../audios/page-52.mp3",
            title: "44-Page 52",
            tags: ["dubstep"],
        },
        {
            url: "../../audios/page-53.mp3",
            title: "45-Page 53",
            tags: ["dubstep"],
        },
        {
            url: "../../audios/page-54.mp3",
            title: "46-Page 54",
            tags: ["dubstep"],
        },
        {
            url: "../../audios/page-55.mp3",
            title: "47-Page 55",
            tags: ["dubstep"],
        },
        {
            url: "../../audios/page-56.mp3",
            title: "48-Page 56",
            tags: ["dubstep"],
        },
        {
            url: "../../audios/page-57.mp3",
            title: "49-Page 57",
            tags: ["dubstep"],
        },
        {
            url: "../../audios/page-58.mp3",
            title: "50-Page 58",
            tags: ["dubstep"],
        },
        {
            url: "../../audios/page-59.mp3",
            title: "51-Page 59",
            tags: ["dubstep"],
        },
        {
            url: "../../audios/page-60.mp3",
            title: "52-Page 60",
            tags: ["dubstep"],
        },
        {
            url: "../../audios/page-61.mp3",
            title: "53-Page 61",
            tags: ["dubstep"],
        },
        {
            url: "../../audios/page-62.mp3",
            title: "54-Page 62",
            tags: ["dubstep"],
        },
        {
            url: "../../audios/page-63.mp3",
            title: "55-Page 63",
            tags: ["dubstep"],
        },
        {
            url: "../../audios/page-64.mp3",
            title: "56-Page 64",
            tags: ["dubstep"],
        },
        {
            url: "../../audios/page-65.mp3",
            title: "57-Page 65",
            tags: ["dubstep"],
        },
        {
            url: "../../audios/page-66.mp3",
            title: "58-Page 66",
            tags: ["dubstep"],
        },
        {
            url: "../../audios/page-67.mp3",
            title: "59-Page 67",
            tags: ["dubstep"],
        },
        {
            url: "../../audios/page-68.mp3",
            title: "60-Page 68",
            tags: ["dubstep"],
        },
        {
            url: "../../audios/page-69.mp3",
            title: "61-Page 69",
            tags: ["dubstep"],
        },
        {
            url: "../../audios/page-70.mp3",
            title: "62-Page 70",
            tags: ["dubstep"],
        },
        {
            url: "../../audios/page-71.mp3",
            title: "63-Page 71",
            tags: ["dubstep"],
        },
        {
            url: "../../audios/page-72.mp3",
            title: "64-Page 72",
            tags: ["dubstep"],
        },
        {
            url: "../../audios/page-73.mp3",
            title: "65-Page 73",
            tags: ["dubstep"],
        },
        {
            url: "../../audios/page-74.mp3",
            title: "66-Page 74",
            tags: ["dubstep"],
        },
        {
            url: "../../audios/page-75.mp3",
            title: "67-Page 75",
            tags: ["dubstep"],
        },
        {
            url: "../../audios/page-76.mp3",
            title: "68-Page 76",
            tags: ["dubstep"],
        },
        {
            url: "../../audios/page-77.mp3",
            title: "69-Page 77",
            tags: ["dubstep"],
        },
        {
            url: "../../audios/page-78.mp3",
            title: "70-Page 78",
            tags: ["dubstep"],
        },
        {
            url: "../../audios/page-79.mp3",
            title: "71-Page 79",
            tags: ["dubstep"],
        },
        {
            url: "../../audios/page-80.mp3",
            title: "72-Page 80",
            tags: ["dubstep"],
        },
        {
            url: "../../audios/page-81.mp3",
            title: "73-Page 81",
            tags: ["dubstep"],
        },
        {
            url: "../../audios/page-82.mp3",
            title: "74-Page 82",
            tags: ["dubstep"],
        },
        {
            url: "../../audios/page-83.mp3",
            title: "75-Page 83",
            tags: ["dubstep"],
        },
        {
            url: "../../audios/page-84.mp3",
            title: "76-Page 84",
            tags: ["dubstep"],
        },
        {
            url: "../../audios/page-85.mp3",
            title: "77-Page 85",
            tags: ["dubstep"],
        },
        {
            url: "../../audios/page-86.mp3",
            title: "78-Page 86",
            tags: ["dubstep"],
        },
        {
            url: "../../audios/page-87.mp3",
            title: "79-Page 87",
            tags: ["dubstep"],
        },
        {
            url: "../../audios/page-88.mp3",
            title: "80-Page 88",
            tags: ["dubstep"],
        },
        {
            url: "../../audios/page-89.mp3",
            title: "81-Page 89",
            tags: ["dubstep"],
        },
        {
            url: "../../audios/page-90.mp3",
            title: "82-Page 90",
            tags: ["dubstep"],
        },
        {
            url: "../../audios/page-91.mp3",
            title: "83-Page 91",
            tags: ["dubstep"],
        },
        {
            url: "../../audios/page-92.mp3",
            title: "84-Page 92",
            tags: ["dubstep"],
        }
    ];

    return (
        <Player 
            trackList={tracks}
            includeTags={false}
            ncludeSearch={true}
            showPlaylist={true}
            autoPlayNextTrack={true}
            customColorScheme={colors}
        />
    )
}

export default Reproductor